import axios from "axios";

export const descargarDocumento = async (ubicacion) => {
  try {
    const response = await axios.get(
      `https://suadesarrollo.azurewebsites.net/api/AzureStorage/Descargar?ubicacion=${encodeURIComponent(
        ubicacion,
      )}`,
      {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      },
    );

    const url =
      typeof response.data === "string" ? response.data : response.data.url;

    // ✅ Abre en otra pestaña
    window.open(url, "_blank");
  } catch (error) {
    console.error("Error descargando documento:", error);
  }
};
